import { CustomText } from '../../../lib/utils/types/slate';

export const addBlockStyling = (node: CustomText): string => {
	let styledNode = node.text as string;

	if (node.bold) {
		styledNode = `<strong>${styledNode}</strong>`;
	}

	if (node.code) {
		styledNode = `<code>${styledNode}</code>`;
	}

	if (node.italic) {
		styledNode = `<em>${styledNode}</em>`;
	}

	if (node.underline) {
		styledNode = `<u>${styledNode}</u>`;
	}

	return styledNode;
};
